{
  "name": "@nextgis/ngw-connector",
  "version": "3.0.1",
  "_priority": 12,
  "description": "A lightweight HTTP client optimized for use with NextGIS Web API",
  "main": "index.js",
  "module": "lib/ngw-connector.esm-bundler.js",
  "unpkg": "lib/ngw-connector.global.prod.js",
  "jsdelivr": "lib/ngw-connector.global.prod.js",
  "types": "lib/index.d.ts",
  "dependencies": {
    "@nextgis/cache": "3.0.0",
    "@nextgis/cancelable-promise": "3.0.0",
    "@nextgis/utils": "3.0.0",
    "@types/events": "^3.0.0",
    "events": "*",
    "form-data": "^4.0.0"
  },
  "devDependencies": {
    "@nextgis/build-tools": "3.0.0"
  },
  "scripts": {
    "clean": "rimraf ./lib",
    "dev": "node ../build-tools/lib/build.js",
    "prod": "npm run dev -- --release",
    "lint": "eslint ./src/**/*.ts --fix --c ../../.eslintrc",
    "watch": "npm run dev -- --watch",
    "gen:types": "node ./scripts/generator"
  },
  "buildOptions": {
    "name": "NgwConnector",
    "formats": [
      "esm-bundler",
      "esm-browser",
      "cjs",
      "global"
    ]
  },
  "keywords": [
    "NextGIS",
    "MAP"
  ],
  "author": "NextGIS",
  "files": [
    "index.js",
    "lib"
  ],
  "license": "MIT",
  "homepage": "https://github.com/nextgis/nextgis_frontend/tree/master/packages/ngw-connector#readme",
  "repository": {
    "type": "git",
    "url": "git://github.com/nextgis/nextgis_frontend.git"
  },
  "engines": {
    "node": ">=18.20.4"
  },
  "gitHead": "edc68033f914f6c95c4125b9738bba6d36e990b4"
}
